function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import * as Api from "../ajax/SessionApi";
import IntlMessage from '../commons/Intl';
import { Action, AuthoringDataPanel, Label, Placeholder } from '../commons/IntlMessages';
import UploadDataMaterialsInstanceModel from "../models/session/UploadDataMaterialsInstanceModel";
import UploadDataMaterialsParamInstanceModel from "../models/session/UploadDataMaterialsParamInstanceModel"; //import UploadDataMaterialsItemInstanceModel from "../models/session/UploadDataMaterialsItemInstanceModel";

var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language); // オーサリングデータパネル管理モーダル

/**
 * モード
 */

export var Mode;

(function (Mode) {
  /**
   * なし
   */
  Mode[Mode["None"] = 0] = "None";
  /**
   * 追加
   */

  Mode[Mode["Add"] = 1] = "Add";
})(Mode || (Mode = {}));
/**
 * データパネル管理モーダルコンポーネント
 */


var SessionAuthoringDataPanelModalComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(SessionAuthoringDataPanelModalComponent, _React$Component);

  var _super = _createSuper(SessionAuthoringDataPanelModalComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function SessionAuthoringDataPanelModalComponent(props) {
    var _this;

    _classCallCheck(this, SessionAuthoringDataPanelModalComponent);

    _this = _super.call(this, props);

    switch (props.mode) {
      case Mode.Add:
        _this.state = {
          Modal: null,
          SessionId: _this.props.sessionId,
          SearchText: "",
          DataList: [],
          SelectedData: null,
          IsNew: false,
          ErrorMessages: []
        };
        break;

      default:
        throw Error();
    }

    _this.getUploadDataMaterialsList(_this.props.sessionId, null);

    return _this;
  }
  /**
   * 会議素材（データ）一覧取得
   *
   * @param sessionId 会議ID
   * @param dataId データID
   */


  _createClass(SessionAuthoringDataPanelModalComponent, [{
    key: "getUploadDataMaterialsList",
    value: function getUploadDataMaterialsList(sessionId, dataId) {
      var _this2 = this;

      Api.GetUploadDataMaterialsList(this.props.sessionId, function (data) {
        _this2.setState({
          DataList: data.UploadDataMaterialsList
        }, function () {
          if (dataId != null && dataId != "") {
            _this2.getUploadDataMaterials(_this2.props.sessionId, Number(dataId));
          }
        });
      });
    }
    /**
     * 会議素材（データ）取得
     *
     * @param sessionId 会議ID
     * @param dataId メッセージID
     */

  }, {
    key: "getUploadDataMaterials",
    value: function getUploadDataMaterials(sessionId, dataId) {
      var _this3 = this;

      Api.GetUploadDataMaterials(sessionId, dataId, function (data) {
        _this3.setState({
          SelectedData: data,
          IsNew: false
        });
      });
    }
    /**
     * 「データを追加」ボタン押下時の処理を行います。
     */

  }, {
    key: "addData",
    value: function addData() {
      var newId = 0;

      if (this.state.DataList.length > 0) {
        for (var i = 0; i < this.state.DataList.length; i++) {
          if (newId < this.state.DataList[i].DataId) newId = this.state.DataList[i].DataId;
        }

        newId++;
      }

      var data = new UploadDataMaterialsInstanceModel();
      data.SessionId = this.props.sessionId;
      data.DataId = newId;
      this.setState({
        SelectedData: data,
        IsNew: true
      });
    }
    /**
     * 「データを更新」ボタン押下時の処理を行います。
     */

  }, {
    key: "updateData",
    value: function updateData() {
      var _this4 = this;

      if (this.state.Modal == null) {
        throw Error();
      }

      if (this.state.SelectedData == null) return;
      var form = $("#MainForm");
      $.validator.unobtrusive.parse(form);
      form.validate();

      if (form.valid()) {
        this.state.ErrorMessages.length = 0;

        if (this.state.ErrorMessages.length != 0) {
          this.setState({
            ErrorMessages: this.state.ErrorMessages
          });
          return;
        }

        var message = JSON.stringify(this.state.SelectedData);

        if (this.state.IsNew) {
          Api.AddUploadDataMaterials(message, function () {
            _this4.setState({
              SelectedData: null,
              IsNew: false
            }, function () {
              _this4.getUploadDataMaterialsList(_this4.props.sessionId, null);
            });
          });
        } else {
          Api.ModifyUploadDataMaterials(message, function () {
            _this4.setState({
              SelectedData: null,
              IsNew: false
            }, function () {
              _this4.getUploadDataMaterialsList(_this4.props.sessionId, null);
            });
          });
        }
      }
    }
    /**
     * 「データを複製」ボタン押下時の処理を行います。
     */

  }, {
    key: "copyData",
    value: function copyData() {
      var _this5 = this;

      if (this.state.SelectedData == null) return;
      var newId = 0;

      if (this.state.DataList.length > 0) {
        for (var i = 0; i < this.state.DataList.length; i++) {
          if (newId < this.state.DataList[i].DataId) newId = this.state.DataList[i].DataId;
        }

        newId++;
      }

      var data = this.state.SelectedData;
      Api.CopyUploadDataMaterials(data.SessionId, newId, data.DataId, function () {
        _this5.setState({
          SelectedData: null,
          IsNew: false
        }, function () {
          _this5.getUploadDataMaterialsList(_this5.props.sessionId, String(newId));
        });
      });
    }
    /**
     * 「データを削除」ボタン押下時の処理を行います。
     */

  }, {
    key: "delData",
    value: function delData() {
      var _this6 = this;

      if (this.state.SelectedData == null) return;
      var data = this.state.SelectedData;
      Api.DeleteUploadDataMaterials(data.SessionId, data.DataId, function () {
        _this6.setState({
          SelectedData: null,
          IsNew: false
        }, function () {
          _this6.getUploadDataMaterialsList(_this6.props.sessionId, null);
        });
      });
    }
    /**
     * データの選択状態を切り替えます
     *
     * @param m モデル
     */

  }, {
    key: "changeSelectedData",
    value: function changeSelectedData(m) {
      var _this7 = this;

      //前回と同じ場合は、未選択
      if (this.state.SelectedData != null && this.state.SelectedData == m) {
        this.setState({
          SelectedData: null,
          IsNew: false
        });
        return;
      }

      this.setState({
        SelectedData: m,
        IsNew: false
      }, function () {
        if (_this7.state.SelectedData == null) return;
        var data = _this7.state.SelectedData;

        _this7.getUploadDataMaterials(data.SessionId, data.DataId);
      });
    }
    /**
     * 「データパラメーターを追加」ボタン押下時の処理を行います。
     */

  }, {
    key: "addDataParam",
    value: function addDataParam() {
      if (this.state.SelectedData == null) return;
      var data = this.state.SelectedData;
      var paramId = 0;

      if (data.DataParams != null && data.DataParams.length > 0) {
        paramId = data.DataParams.length;
      }

      var dataParam = new UploadDataMaterialsParamInstanceModel();
      dataParam.SessionId = data.SessionId;
      dataParam.DataId = data.DataId;
      dataParam.ParamId = paramId;
      data.DataParams.push(dataParam);
      this.setState({
        SelectedData: data
      });
    }
    /**
     * データパラメーター名を更新します。
     */

  }, {
    key: "updateDataParamName",
    value: function updateDataParamName(e, index) {
      if (this.state.SelectedData == null) return;
      var data = this.state.SelectedData;
      if (data.DataParams.length <= index) return;
      data.DataParams[index].ParamName = e.target.value.substring(0, e.target.maxLength);
      this.setState({
        SelectedData: data
      });
    }
    /**
     * データパラメーター値を更新します。
     */

  }, {
    key: "updateDataParamValue",
    value: function updateDataParamValue(e, index) {
      if (this.state.SelectedData == null) return;
      var data = this.state.SelectedData;
      if (data.DataParams.length <= index) return;
      data.DataParams[index].ParamValue = e.target.value.substring(0, e.target.maxLength);
      this.setState({
        SelectedData: data
      });
    }
    /**
     * 「データパラメーターを削除」ボタン押下時の処理を行います。
     */

  }, {
    key: "delDataParam",
    value: function delDataParam(index) {
      if (this.state.SelectedData == null) return;
      var data = this.state.SelectedData;
      if (data.DataParams.length <= index) return;
      data.DataParams.splice(index, 1);

      for (var i = 0; i < data.DataParams.length; i++) {
        data.DataParams[i].ParamId = i;
      }

      this.setState({
        SelectedData: data
      });
    } ///**
    // * 「データアイテムを追加」ボタン押下時の処理を行います。
    // */
    //private addDataItem(): void {
    //    if (this.state.SelectedData == null)
    //        return;
    //    var data = this.state.SelectedData;
    //    var itemId = 0;
    //    if (data.DataItems != null && data.DataItems.length > 0) {
    //        itemId = data.DataItems.length;
    //    }
    //    var dataItem = new UploadDataMaterialsItemInstanceModel();
    //    dataItem.SessionId = data.SessionId;
    //    dataItem.DataId = data.DataId;
    //    dataItem.ItemId = itemId;
    //    data.DataItems.push(dataItem);
    //    this.setState({
    //        SelectedData: data
    //    });
    //}
    ///**
    // * データアイテムを更新します。
    // */
    //private updateDataItem(e: React.ChangeEvent<HTMLInputElement>, index: number): void {
    //    if (this.state.SelectedData == null)
    //        return;
    //    var data = this.state.SelectedData;
    //    if (data.DataItems.length <= index)
    //        return;
    //    data.DataItems[index].ItemName = e.target.value.substring(0, e.target.maxLength);
    //    this.setState({
    //        SelectedData: data
    //    });
    //}
    ///**
    // * 「データアイテムを削除」ボタン押下時の処理を行います。
    // */
    //private delDataItem(index: number): void {
    //    if (this.state.SelectedData == null)
    //        return;
    //    var data = this.state.SelectedData;
    //    if (data.DataItems.length <= index)
    //        return;
    //    data.DataItems.splice(index, 1);
    //    for (var i = 0; i < data.DataItems.length; i++) {
    //        data.DataItems[i].ItemId = i;
    //    }
    //    this.setState({
    //        SelectedData: data
    //    });
    //}

    /**
     * タイトルを更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateTitle",
    value: function updateTitle(e) {
      if (this.state.SelectedData == null) return;
      var data = this.state.SelectedData;
      data.Title = e.target.value.substring(0, e.target.maxLength);
      this.setState({
        SelectedData: data
      });
    }
    /**
     * データの取得先を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateDataUrl",
    value: function updateDataUrl(e) {
      if (this.state.SelectedData == null) return;
      var data = this.state.SelectedData;
      data.DataUrl = e.target.value.substring(0, e.target.maxLength);
      this.setState({
        SelectedData: data
      });
    }
    /**
     * 「戻る」ボタン押下時の処理を行います。
     */

  }, {
    key: "onBack",
    value: function onBack() {
      if (this.state.Modal == null) {
        throw Error();
      }

      this.props.onBack();
      this.state.Modal.modal('hide');
    }
    /**
     * 検索テキストを更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateSearchText",
    value: function updateSearchText(e) {
      this.setState({
        SearchText: e.target.value.substring(0, e.target.maxLength)
      });
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this8 = this;

      var modal = $('#SessionAuthoringDataPanelDialogModal');
      this.setState({
        Modal: modal
      });
      modal.modal({
        backdrop: 'static',
        keyboard: false
      }); // ポップアップが完全に非表示になった時のイベント。

      modal.on("hidden.bs.modal", function () {
        _this8.props.onHidden();
      });
      $("form").removeData("validator").removeData("unobtrusiveValidation").off("submit.validate click.validate focusin.validate focusout.validate keyup.validate invalid-form.validate");
      $.validator.unobtrusive.parse("form");
    }
    /**
     * 接続情報を展開します。
     */

  }, {
    key: "onViewConnection",
    value: function onViewConnection() {
      var target = document.querySelector('.dataListItem__connection__cont');

      if (target) {
        target.classList.toggle('dataListItem__connection__cont--hide');
      }

      var targetBtn = document.querySelector('.dataListItem__connection__toggleBtn');

      if (targetBtn) {
        targetBtn.classList.toggle('dataListItem__connection__toggleBtn--open');
      }
    }
    /**
     * データ情報を展開します。
     */

  }, {
    key: "onViewData",
    value: function onViewData() {
      var target = document.querySelector('.dataListItem__data__cont');

      if (target) {
        target.classList.toggle('dataListItem__data__cont--hide');
      }

      var targetBtn = document.querySelector('.dataListItem__data__toggleBtn');

      if (targetBtn) {
        targetBtn.classList.toggle('dataListItem__data__toggleBtn--open');
      }
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      var _this9 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "SessionAuthoringDataPanelDialogModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, this.state.ErrorMessages.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "validation-summary-errors alert alert-danger"
      }, /*#__PURE__*/React.createElement("ul", null, this.state.ErrorMessages.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          key: i
        }, x);
      }))), /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "48",
        height: "38",
        src: "/assets/img/Icon_DataPanel_Grey.svg"
      }), /*#__PURE__*/React.createElement("h3", null, intl.format(AuthoringDataPanel.Title))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "modal-close",
        "data-dismiss": "modal",
        "aria-label": "Close",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
        className: "modal-body newdesign"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-4"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 dataMain__headerBtnArea"
      }, /*#__PURE__*/React.createElement("button", {
        className: "dataMain__addBtn",
        onClick: this.addData.bind(this),
        type: "button"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Add.svg"
      }), /*#__PURE__*/React.createElement("p", null, intl.format(Action.AddDataPanel))), this.state.SelectedData != null && !this.state.IsNew && [/*#__PURE__*/React.createElement("button", {
        className: "dataMain__copyBtn",
        onClick: this.copyData.bind(this),
        type: "button"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Duplicate_Grey.svg"
      })), /*#__PURE__*/React.createElement("button", {
        className: "dataMain__delBtn",
        onClick: this.delData.bind(this),
        type: "button"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/delete_icon.svg"
      }))], this.state.SelectedData != null && this.state.IsNew && [/*#__PURE__*/React.createElement("button", {
        className: "dataMain__copyBtn",
        disabled: true,
        onClick: this.copyData.bind(this),
        type: "button"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Duplicate_Grey.svg"
      })), /*#__PURE__*/React.createElement("button", {
        className: "dataMain__delBtn",
        onClick: this.delData.bind(this),
        type: "button"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/delete_icon.svg"
      }))], this.state.SelectedData == null && [/*#__PURE__*/React.createElement("button", {
        className: "dataMain__copyBtn",
        disabled: true,
        onClick: this.copyData.bind(this),
        type: "button"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Duplicate_Grey.svg"
      })), /*#__PURE__*/React.createElement("button", {
        className: "dataMain__delBtn",
        disabled: true,
        onClick: this.delData.bind(this),
        type: "button"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/delete_icon.svg"
      }))]), /*#__PURE__*/React.createElement("div", {
        className: "col-12 form-inline select-wrap-top"
      }, /*#__PURE__*/React.createElement("div", {
        className: "input-group col-12"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control",
        maxLength: 40,
        onChange: function onChange(e) {
          return _this9.updateSearchText(e);
        },
        value: this.state.SearchText,
        tabIndex: 101,
        placeholder: intl.format(Placeholder.SearchWord)
      }))), /*#__PURE__*/React.createElement("div", {
        className: "select-wrap-bottom"
      }, this.state.DataList.length == 0 && /*#__PURE__*/React.createElement("div", {
        className: "col-12 list-group list-group-flush list-group-data"
      }, intl.format(AuthoringDataPanel.NoDataPanel)), this.state.DataList.length > 0 && /*#__PURE__*/React.createElement("ul", {
        className: "col-12 list-group list-group-flush"
      }, this.state.DataList.filter(function (x) {
        return x.Title.indexOf(_this9.state.SearchText) >= 0;
      }).map(function (x, _i) {
        return /*#__PURE__*/React.createElement("li", {
          onClick: _this9.changeSelectedData.bind(_this9, x),
          className: "list-group-item " + (_this9.state.SelectedData != null && _this9.state.SelectedData.DataId == x.DataId ? "selected" : "")
        }, /*#__PURE__*/React.createElement("p", null, x.Title));
      })))), /*#__PURE__*/React.createElement("div", {
        className: "col-7 offset-left"
      }, this.state.SelectedData != null && [/*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-2 col-form-label",
        htmlFor: "Title"
      }, intl.format(Label.Title)), /*#__PURE__*/React.createElement("div", {
        className: "col-10"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control",
        name: "Title",
        id: "Title",
        maxLength: 40,
        onChange: function onChange(e) {
          return _this9.updateTitle(e);
        },
        value: this.state.SelectedData.Title,
        tabIndex: 102,
        placeholder: intl.format(Placeholder.Letters, {
          value: "40"
        })
      }))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "mainContent__list"
      }, /*#__PURE__*/React.createElement("li", {
        className: "dataListItem"
      }, /*#__PURE__*/React.createElement("div", {
        className: "dataListItem__header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "dataListItem__headerContWrapper",
        onClick: this.onViewConnection.bind(this)
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "dataListItem__connection__toggleBtn"
      }, /*#__PURE__*/React.createElement("div", {
        className: "dataListItem__connection__toggleBtnIcon"
      })))), /*#__PURE__*/React.createElement("div", {
        className: "dataListItem__connection__cont dataListItem__connection__cont--hide"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-2 col-form-label",
        htmlFor: "DataUrl"
      }, intl.format(Label.DataAcquisitionSource)), /*#__PURE__*/React.createElement("div", {
        className: "col-10"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control",
        name: "DataUrl",
        id: "DataUrl",
        maxLength: 256,
        onChange: function onChange(e) {
          return _this9.updateDataUrl(e);
        },
        value: this.state.SelectedData.DataUrl,
        tabIndex: 103,
        placeholder: intl.format(Placeholder.Letters, {
          value: "256"
        })
      }))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-2 col-form-label",
        htmlFor: "Parameter"
      }, intl.format(Label.OptionParameter)), /*#__PURE__*/React.createElement("div", {
        className: "col-10"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "authoring"
      }, /*#__PURE__*/React.createElement("div", {
        className: "authoringMain"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "authoringConts"
      }, this.state.SelectedData.DataParams != null && this.state.SelectedData.DataParams.length > 0 && this.state.SelectedData.DataParams.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          className: "authoringCont"
        }, /*#__PURE__*/React.createElement("ul", {
          className: "authoringCont__list"
        }, /*#__PURE__*/React.createElement("li", {
          className: "authoringCont__item"
        }, /*#__PURE__*/React.createElement("input", {
          type: "text",
          className: "form-control",
          name: "ParamName",
          id: "ParamName",
          maxLength: 40,
          onChange: function onChange(e) {
            return _this9.updateDataParamName(e, i);
          },
          value: x.ParamName,
          tabIndex: 201,
          placeholder: intl.format(Placeholder.Letters, {
            value: "40"
          })
        })), /*#__PURE__*/React.createElement("li", {
          className: "authoringCont__item"
        }, /*#__PURE__*/React.createElement("input", {
          type: "text",
          className: "form-control",
          name: "ParamValue",
          id: "ParamValue",
          maxLength: 40,
          onChange: function onChange(e) {
            return _this9.updateDataParamValue(e, i);
          },
          value: x.ParamValue,
          tabIndex: 202,
          placeholder: intl.format(Placeholder.Letters, {
            value: "40"
          })
        })), /*#__PURE__*/React.createElement("li", {
          className: "authoringCont__item authoringCont__item--btn"
        }, /*#__PURE__*/React.createElement("button", {
          className: "authoringCont__btn authoringCont__btn--del",
          onClick: _this9.delDataParam.bind(_this9, i),
          type: "button"
        }, /*#__PURE__*/React.createElement("img", {
          src: "/assets/img/delete_icon.svg"
        })))));
      })), this.state.SelectedData != null && this.state.SelectedData.DataParams != null && this.state.SelectedData.DataParams.length < 6 && /*#__PURE__*/React.createElement("button", {
        className: "authoringMain__addBtn",
        onClick: this.addDataParam.bind(this),
        type: "button"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Add.svg"
      }), /*#__PURE__*/React.createElement("p", null, intl.format(Action.AddParam)))))))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-2 col-form-label",
        htmlFor: "DataUrl"
      }, intl.format(Label.LoginInfo)), /*#__PURE__*/React.createElement("div", {
        className: "col-10"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control",
        name: "DataUrl",
        id: "DataUrl",
        maxLength: 256,
        onChange: function onChange(e) {
          return _this9.updateDataUrl(e);
        },
        value: this.state.SelectedData.DataUrl,
        tabIndex: 103,
        placeholder: intl.format(Placeholder.Letters, {
          value: "256"
        })
      }))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-2 col-form-label",
        htmlFor: "DataUrl"
      }, intl.format(Label.AcquisitionFrequency)), /*#__PURE__*/React.createElement("div", {
        className: "col-10"
      }, /*#__PURE__*/React.createElement("select", {
        className: "authoringCont__select",
        onChange: function onChange(e) {},
        value: this.state.SelectedData.Frequency
      }, /*#__PURE__*/React.createElement("option", {
        className: "placeholder"
      }, intl.format(Label.AcquisitionFrequency)), /*#__PURE__*/React.createElement("optgroup", {
        label: intl.format(Label.AcquisitionFrequency)
      }, /*#__PURE__*/React.createElement("option", {
        value: "1"
      }, "Default"), /*#__PURE__*/React.createElement("option", {
        value: "10"
      }, "x 1/10"), /*#__PURE__*/React.createElement("option", {
        value: "60"
      }, "x 1/5"), /*#__PURE__*/React.createElement("option", {
        value: "300"
      }, "x 1/3"), /*#__PURE__*/React.createElement("option", {
        value: "600"
      }, "x 1/2"), /*#__PURE__*/React.createElement("option", {
        value: "1800"
      }, "x 1"), /*#__PURE__*/React.createElement("option", {
        value: "3600"
      }, "x 1.5")))))))))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "mainContent__list"
      }, /*#__PURE__*/React.createElement("li", {
        className: "dataListItem"
      }, /*#__PURE__*/React.createElement("div", {
        className: "dataListItem__header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "dataListItem__headerContWrapper",
        onClick: this.onViewData.bind(this)
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "dataListItem__data__toggleBtn"
      }, /*#__PURE__*/React.createElement("div", {
        className: "dataListItem__data__toggleBtnIcon"
      })), /*#__PURE__*/React.createElement("div", {
        className: "dataItem__headerCont"
      }, /*#__PURE__*/React.createElement("div", {
        className: "dataListItem__headerContText"
      }, "\u8868\u793A\u3059\u308B\u30C7\u30FC\u30BF")))), /*#__PURE__*/React.createElement("div", {
        className: "dataListItem__data__cont dataListItem__data__cont--hide"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-2 col-form-label",
        htmlFor: "Item"
      }, intl.format(Label.OptionParameter)), /*#__PURE__*/React.createElement("div", {
        className: "col-10"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "authoring"
      }, /*#__PURE__*/React.createElement("div", {
        className: "authoringMain"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "authoringConts"
      }, this.state.SelectedData.DataParams != null && this.state.SelectedData.DataParams.length > 0 && this.state.SelectedData.DataParams.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          className: "authoringCont"
        }, /*#__PURE__*/React.createElement("ul", {
          className: "authoringCont__list"
        }, /*#__PURE__*/React.createElement("li", {
          className: "authoringCont__item"
        }, /*#__PURE__*/React.createElement("input", {
          type: "text",
          className: "form-control",
          name: "ParamName",
          id: "ParamName",
          maxLength: 40,
          onChange: function onChange(e) {
            return _this9.updateDataParamName(e, i);
          },
          value: x.ParamName,
          tabIndex: 201,
          placeholder: intl.format(Placeholder.Letters, {
            value: "40"
          })
        })), /*#__PURE__*/React.createElement("li", {
          className: "authoringCont__item"
        }, /*#__PURE__*/React.createElement("input", {
          type: "text",
          className: "form-control",
          name: "ParamValue",
          id: "ParamValue",
          maxLength: 40,
          onChange: function onChange(e) {
            return _this9.updateDataParamValue(e, i);
          },
          value: x.ParamValue,
          tabIndex: 202,
          placeholder: intl.format(Placeholder.Letters, {
            value: "40"
          })
        })), /*#__PURE__*/React.createElement("li", {
          className: "authoringCont__item authoringCont__item--btn"
        }, /*#__PURE__*/React.createElement("button", {
          className: "authoringCont__btn authoringCont__btn--del",
          onClick: _this9.delDataParam.bind(_this9, i),
          type: "button"
        }, /*#__PURE__*/React.createElement("img", {
          src: "/assets/img/delete_icon.svg"
        })))));
      })), this.state.SelectedData != null && this.state.SelectedData.DataParams != null && this.state.SelectedData.DataParams.length < 6 && /*#__PURE__*/React.createElement("button", {
        className: "authoringMain__addBtn",
        onClick: this.addDataParam.bind(this),
        type: "button"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Add.svg"
      }), /*#__PURE__*/React.createElement("p", null, intl.format(Action.AddParam)))))))))))))])))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-11 mx-auto"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-4 textAlignCenter"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-default",
        type: "button",
        onClick: this.onBack.bind(this),
        tabIndex: -1
      }, intl.format(Action.Back))), /*#__PURE__*/React.createElement("div", {
        className: "col-7 offset-left textAlignCenter"
      }, this.state.SelectedData != null && /*#__PURE__*/React.createElement("button", {
        className: "btn btn-primary",
        type: "button",
        onClick: this.updateData.bind(this),
        tabIndex: -1
      }, intl.format(Action.Entry)))))))));
    }
  }]);

  return SessionAuthoringDataPanelModalComponent;
}(React.Component);

export { SessionAuthoringDataPanelModalComponent as default };